export default "__VITE_ASSET__BVTyRlXJ__"